export const wrap = "mx-auto w-full max-w-[1180px] px-4 sm:px-6";
export const h2 = "font-display text-[clamp(2.2rem,5.4vw,3.9rem)] font-bold leading-[1.04] tracking-[-0.04em] text-ink text-balance";

/** The trailing words of a heading, faded back so the first words lead. */
export const fade = "text-muted";

/** The handwritten aside face. Loaded by the landing only, so the app never pays for it. */
export const script = "font-['Caveat',cursive] font-semibold tracking-normal";
export const scriptHref = "https://fonts.googleapis.com/css2?family=Caveat:wght@600&display=swap";

/** Every mock row and card on the landing sits on this: white, hairline, small radius. */
export const tile = "rounded-card bg-surface shadow-card";
